import React from "react";
import { useTranslation } from "react-i18next";
import { map } from "lodash";
import { TextVariant } from "@/components/ui/text";
import ConfidenceLevelIcon from "@/components/controls/ConfidenceLevelIcon";
import SingleSelect from "@/components/controls/SingleSelect";
import { CsmRenewalConfidenceLevel } from "@/pages/deals/types";
import { csmRenewalConfidenceLevels } from "@/pages/deals/helpers";
import { getEnumTKey } from "@/utils/strings";

interface Props {
  value: CsmRenewalConfidenceLevel | null | undefined;
  valueVariant: TextVariant;
  onUpdateField: (field: string, newValue: number) => void;
}

const RenewalConfidenceKPI: React.FC<Props> = ({
  value,
  valueVariant,
  onUpdateField
}) => {
  const { t } = useTranslation();

  return (
    <SingleSelect
      fieldName="csmRenewalConfidenceLevel"
      options={map(csmRenewalConfidenceLevels, (level) => ({
        id: level,
        name: CsmRenewalConfidenceLevel[level]
      }))}
      formatter={(optionValue) =>
        t(
          getEnumTKey(
            "deals",
            "levels",
            CsmRenewalConfidenceLevel,
            optionValue as number
          )
        )
      }
      selectedValue={value ? Number(value) : undefined}
      renderIcon={(optionValue) => (
        <ConfidenceLevelIcon value={Number(optionValue)} />
      )}
      onSelection={(newValue) =>
        onUpdateField("csmRenewalConfidenceLevel", Number(newValue))
      }
      triggerVariant={valueVariant}
    />
  );
};

export default RenewalConfidenceKPI;
